




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { CampaignItemPaymentType } from '@/modules/campaign-item-payment/models/campaign-item-payment-resource.model'

@Component
export default class CampaignItemPaymentTypeView extends Vue {
  @Prop({ required: true }) type!: CampaignItemPaymentType
  @Prop({ required: true }) types!: { [key in CampaignItemPaymentType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case CampaignItemPaymentType.CASH:
        return 'text-green'
      case CampaignItemPaymentType.FREE:
        return 'text-orange'
      case CampaignItemPaymentType.NONE:
        return 'text-tes-blue'
      case CampaignItemPaymentType.INCREASE:
        return 'text-tes-blue'
      case CampaignItemPaymentType.RESERVATION:
        return 'text-tes-red'
      default:
        return ''
    }
  }
}
